// KWANKGM04270_近代化資金借入申込 確認
// KWANKGM04240_借入申込希望書兼経営改善資金計画書 確認
import React from 'react';
import { loan_types } from '../../Const';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import FileUpload from '../../templates/FileUpload';
import LoadingModal from '../../molecules/LoadingModal';
import { StepNavigation as StepType } from '../../types/Template';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import ModernizationFundsExaminationFinalConfirmationFooter from '../../organisms/ModernizationFundsExaminationFinalConfirmationFooter';

interface Props {
  reception_id: number;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  status_code: number;
  step_navigation: StepType;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  is_loading: boolean;
  looks_inactive: boolean;
  reception_cd: string;
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  show_error_nav: boolean;
  display_status: boolean;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  loan_type: string;
  has_debtor: boolean;
  callApi: (function_name: string) => Promise<any>;
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
}

const ModernizationFundsExaminationFinalConfirmation: React.FC<Props> = ({
  reception_id,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  status_code,
  step_navigation,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  parent_shelfs,
  child_shelfs,
  contents,
  is_loading,
  looks_inactive,
  reception_cd,
  guarantors_num,
  guarantor_info,
  show_error_nav,
  display_status,
  shelf_info,
  setShelfInfo,
  loan_type,
  has_debtor,
  callApi,
  setParentShelfs,
  setChildShelfs,
  setContents,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  const url = new URL(window.location.href);
  const item_id = url.searchParams.get('item_id');
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        loan_type={item_id}
        guarantor_accordion_hidden={item_id === loan_types.business_improvement_financing_plan}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <ModernizationFundsExaminationFinalConfirmationFooter
        has_debtor={has_debtor}
        reception_id={reception_id}
        status_code={status_code}
        reception_cd={reception_cd}
      />

      <LoadingModal show={is_loading} />
    </>
  );
};

export default ModernizationFundsExaminationFinalConfirmation;
